import createSvgIcon from "./utils/create_icon"

const Redo = createSvgIcon(<path d="M16.293 5.293a1 1 0 0 0 0 1.414L18.586 9H7a5 5 0 0 0 0 10h3a1 1 0 1 0 0-2H7a3 3 0 1 1 0-6h11.586l-2.293 2.293a1 1 0 0 0 1.414 1.414l4-4a1 1 0 0 0 0-1.414l-4-4a1 1 0 0 0-1.414 0Z" fill="currentColor" />, "Redo")
export default Redo
